import React from 'react'

export default function PNF() {
  return (
    <div style={{height:"74vh" }}>
      <h1 style={{color: 'white'}}>
        Page Not Found
        404
      </h1>
    </div>
  )
}
